export default {
  data() {
    return {
      completed: 0,
    };
  },

  methods: {
    markCompleted() {
      if (!this.completed) {
        this.completed = 1;
        this.$emit("completed");
      }
    },
    initializeCompletedTracking() {
      this.completed = 0;
    },
  },
};
